/* tslint:disable */

/**
 */
export class CompanyCreate {
    phone?: string;
    id?: number;
    subname?: string;
    fullname?: string;
    address?: string;
    print_at?: string;
    tax_code?: string;
    name?: string;
    logo?: string;
    email?: string;
    username?: string;
    password?: string;
    lat?: number;
    lng?: number;
    started_at?: string;
    ended_at?: string;
    parent_id?: number;
}
